export function isNullish(val) {
  return ["", null, void 0].includes(val);
}
